import css from 'styled-jsx/css';
import { colors, fontSizes } from '../../../themes';

export default css`
  .few-results-message {
    margin: -3px 0 6px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .few-results-message span {
    color: ${colors.orange};
    font-weight: 600;
    font-size: ${fontSizes.small};
  }
`;



// WEBPACK FOOTER //
// ./app/common/FewResultsMessages/cars/styles.js